import { render } from "./StoreOrderDetails.vue?vue&type=template&id=42651428"
import script from "./StoreOrderDetails.vue?vue&type=script&lang=js"
export * from "./StoreOrderDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__